import { 
  IsUUID, 
  IsString, 
  IsEnum, 
  IsOptional, 
  IsNumber, 
  Min 
} from 'class-validator';
import { 
  CreateMonitoringsInterface, 
  UpdateMonitoringsInterface 
} from '../../interface/monitorings/modify-monitorings.interface';
import { MonitoringStatus, MonitoringAttachmentsStatus } from '../../interface/monitorings/monitorings-response.interface';
import { Brand, Industry, ProductCategory } from '../../utils/enums.utils';

export class CreateMonitoringsDto implements CreateMonitoringsInterface {

  @IsEnum(MonitoringStatus)
  status!: MonitoringStatus;

  @IsString()
  category!: string;

  @IsOptional()
  @IsString()
  monitoring_remarks!: string | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  buying_amount_vat_inc!: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  selling_amount_vat_inc!: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  estimated_gross_profit!: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  mark_up!: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  selling_amount_vat_ex!: number | null;

  @IsOptional()
  @IsString()
  project_code!: string | null;

  @IsEnum(Industry)
  industry!: Industry;

  @IsEnum(ProductCategory)
  product_category!: ProductCategory;

  @IsEnum(Brand)
  brand!: Brand;

  @IsOptional()
  @IsString()
  project_name!: string | null;

  @IsUUID()
  proposal_id!: string;

  @IsUUID()
  company_id!: string;

  @IsOptional()
  @IsUUID()
  created_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;
}

export class UpdateMonitoringsDto implements UpdateMonitoringsInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsEnum(MonitoringStatus)
  status?: MonitoringStatus;

  @IsOptional()
  @IsString()
  category?: string;

  @IsOptional()
  @IsString()
  monitoring_remarks?: string | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  buying_amount_vat_inc?: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  selling_amount_vat_inc?: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  estimated_gross_profit?: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  mark_up?: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  selling_amount_vat_ex?: number | null;

  @IsOptional()
  @IsString()
  project_code?: string | null;

  @IsOptional()
  @IsEnum(Industry)
  industry?: Industry;

  @IsOptional()
  @IsEnum(ProductCategory)
  product_category?: ProductCategory;

  @IsOptional()
  @IsEnum(Brand)
  brand?: Brand;

  @IsOptional()
  @IsString()
  project_name?: string | null;

  @IsOptional()
  @IsUUID()
  company_id?: string;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;
}